import { clsx } from "clsx";
import type { ComponentProps } from "react";
import styles from "./ScreenReader.module.css";

/**
 * ScreenReader component is used to hide content visually but keep it
 * accessible to screen readers.
 *
 * This is useful for providing additional context or instructions that are not
 * necessary for sighted users.
 *
 * @example
 *
 * ```tsx
 * <ScreenReader>
 *   This content is only visible to screen readers.
 * </ScreenReader>
 * ```
 *
 * @example
 *
 * ```tsx
 * <ScreenReader aria-live="polite">
 *   This content will be announced by screen readers.
 * </ScreenReader>
 * ```
 */
export const ScreenReader = (props: ComponentProps<"span">) => {
  return (
    <span
      {...props}
      className={clsx(styles["screen-reader-only"], props.className)}
    />
  );
};
